import React from 'react';
import { Box, MessageModalLayout, Modal, Text, TextButton, } from '@wix/design-system';
import { useTranslation } from '../../../hooks/use-translation';
export function DeletePremiumModal({ appId, appName, handleClose, msId, }) {
    const t = useTranslation();
    function openPremiumSubscriptions() {
        const premiumSubscriptionsPageUrl = `https://manage.wix.com/dashboard/${msId}/manage-website/plans`;
        window.open(premiumSubscriptionsPageUrl, '_blank');
        handleClose();
    }
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageModalLayout, { title: t('manage-apps.delete-premium.header', {
                name: appName,
            }).replace('&amp;', '&'), primaryButtonText: t('manage-apps.delete-premium.cta'), primaryButtonOnClick: openPremiumSubscriptions, secondaryButtonText: t('manage-apps.delete-premium.cancel'), secondaryButtonOnClick: handleClose, onCloseButtonClick: handleClose, dataHook: "delete-premium-app-modal" },
            React.createElement(Box, { direction: "vertical", gap: "24px", width: "552px" },
                React.createElement(Text, null,
                    t('manage-apps.delete-premium.line1'),
                    t('manage-apps.delete-premium.line2'),
                    React.createElement(Box, { inline: true, marginLeft: "6px" },
                        React.createElement(TextButton, { as: "a", href: t('manage-apps.delete-premium-learn-more-link'), target: "_blank", onClick: handleClose }, t('manage-apps.delete-premium.side-action'))))))));
}
//# sourceMappingURL=delete-premium-modal.js.map